/* Eleven Theory: optional progressive enhancements only.
 * Liquid renders all essential content, links, product forms and newsletter forms.
 * No third-party runtime or tracking script is loaded by this file. */
(function () {
  'use strict';
  if (window.__elevenTheoryTheme) return;
  window.__elevenTheoryTheme = true;
  var cleanups = new Map();
  var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  function motionEnabled() { return document.body.dataset.motion !== 'false' && !reduce.matches; }
  function elements(root, selector) {
    var list = Array.from(root.querySelectorAll(selector));
    if (root.matches && root.matches(selector)) list.unshift(root);
    return list;
  }
  function safely(fn) { try { fn(); } catch (error) { if (window.Shopify && window.Shopify.designMode) console.warn('[Eleven Theory] Optional enhancement skipped.', error); } }
  function enhance(root) {
    elements(root, '[data-et-crowd]').forEach(function (canvas) {
      if (cleanups.has(canvas)) return;
      safely(function () { var dispose = createCrowd(canvas); if (dispose) cleanups.set(canvas, dispose); });
    });
    // Scroll scenes are owned by et-motion.js. Do not duplicate their transforms here.
  }
  function release(root) {
    cleanups.forEach(function (dispose, element) {
      if (element === root || root.contains(element)) { safely(dispose); cleanups.delete(element); }
    });
  }
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-et-menu][open]').forEach(function (menu) {
      menu.open = false;
      var summary = menu.querySelector('summary');
      if (summary) summary.focus();
    });
  });
  document.addEventListener('click', function (event) {
    document.querySelectorAll('[data-et-menu][open]').forEach(function (menu) {
      if (!menu.contains(event.target) || (event.target instanceof Element && event.target.closest('a'))) menu.open = false;
    });
  });
  document.addEventListener('shopify:section:load', function (event) { enhance(event.target); });
  document.addEventListener('shopify:section:unload', function (event) { release(event.target); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { enhance(document); }, { once: true });
  else enhance(document);

  function createCrowd(canvas) {
    var context = canvas.getContext && canvas.getContext('2d');
    var frameElement = canvas.parentElement;
    if (!context || !frameElement || !canvas.dataset.src) return null;
    var disposed = false;
    var loaded = false;
    var frame = 0;
    var lastTime = 0;
    var width = 0;
    var height = 0;
    var dpr = 1;
    var visible = !('IntersectionObserver' in window);
    var walkers = [];
    var sprites = [];
    var image = new Image();
    function stop() { if (frame) cancelAnimationFrame(frame); frame = 0; lastTime = 0; }
    function render(time) {
      frame = 0;
      if (disposed || !loaded || !width || !height) return;
      var moving = visible && !document.hidden && motionEnabled();
      var dt = moving && lastTime ? Math.min((time - lastTime) / 1000, 0.05) : 0;
      lastTime = moving ? time : 0;
      context.setTransform(dpr, 0, 0, dpr, 0, 0);
      context.clearRect(0, 0, width, height);
      walkers.forEach(function (walker) {
        if (moving) {
          walker.x += dt * walker.speed * walker.direction;
          walker.phase += dt * 10;
          if (walker.direction > 0 && walker.x > width + walker.w) walker.x = -walker.w;
          if (walker.direction < 0 && walker.x < -walker.w) walker.x = width + walker.w;
        }
        context.save();
        context.translate(walker.x, walker.y + (moving ? Math.sin(walker.phase) * 2 : 0));
        context.scale(walker.direction, 1);
        context.drawImage(walker.sprite, -walker.w / 2, 0, walker.w, walker.h);
        context.restore();
      });
      if (moving) frame = requestAnimationFrame(render);
    }
    function start() { stop(); render(performance.now()); }
    function resize() {
      if (disposed || !loaded) return;
      var rect = canvas.getBoundingClientRect();
      width = Math.max(0, Math.round(rect.width));
      height = Math.max(0, Math.round(rect.height));
      if (!width || !height) return;
      dpr = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width = Math.round(width * dpr);
      canvas.height = Math.round(height * dpr);
      var count = Math.min(46, Math.max(16, Math.ceil(width / 29)));
      walkers = [];
      for (var i = 0; i < count; i++) {
        var scale = 0.32 + (i % 4) * 0.025;
        var h = image.naturalHeight / 7 * scale;
        var w = image.naturalWidth / 15 * scale;
        walkers.push({ sprite: sprites[(i * 11) % sprites.length], x: (i + 0.4) / count * width, y: height - h - (i % 4) * 24, w: w, h: h, direction: i % 3 === 0 ? -1 : 1, speed: 17 + i % 17, phase: i * 1.7 });
      }
      walkers.sort(function (a, b) { return a.y - b.y; });
      start();
    }
    function imageReady() {
      if (disposed || !image.naturalWidth || !image.naturalHeight) return;
      var tileWidth = image.naturalWidth / 15;
      var tileHeight = image.naturalHeight / 7;
      for (var i = 0; i < 105; i++) {
        var sprite = makeCarryingSprite(image, [(i % 15) * tileWidth, Math.floor(i / 15) * tileHeight, tileWidth, tileHeight], i, canvas.dataset.accent);
        if (sprite) sprites.push(sprite);
      }
      if (!sprites.length) return;
      loaded = true;
      resize();
    }
    image.onload = function () { safely(imageReady); };
    image.onerror = function () { stop(); frameElement.hidden = true; };
    image.src = canvas.dataset.src;
    var intersection = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
      visible = entries[0].isIntersecting;
      if (visible) start(); else stop();
    }, { rootMargin: '100px' }) : null;
    if (intersection) intersection.observe(canvas);
    var resizeObserver = 'ResizeObserver' in window ? new ResizeObserver(resize) : null;
    if (resizeObserver) resizeObserver.observe(frameElement); else window.addEventListener('resize', resize);
    document.addEventListener('visibilitychange', start);
    if (reduce.addEventListener) reduce.addEventListener('change', start);
    return function () {
      disposed = true; stop(); image.onload = null; image.onerror = null;
      if (intersection) intersection.disconnect();
      if (resizeObserver) resizeObserver.disconnect(); else window.removeEventListener('resize', resize);
      document.removeEventListener('visibilitychange', start);
      if (reduce.removeEventListener) reduce.removeEventListener('change', start);
      walkers.length = 0; sprites.length = 0;
    };
  }

  // Carry illustration helpers are appended from the authored project below.
  // Open Peeps illustrations: CC0. Crowd concept: Skiper UI / Zadvorsky.
  // ES module / React / GSAP code is deliberately not needed at runtime.
  function paintCarry(context, style, behind) {
    const ink = "#1b1d1b";
    const edge = "#f4f0e7";
    const signal = context.etAccent || "#ff632d";
    context.lineCap = "round";
    context.lineJoin = "round";
    const shape = (x, y, width, height, radius, fill) => {
        context.beginPath();
        if (typeof context.roundRect === 'function') context.roundRect(x, y, width, height, radius); else context.rect(x, y, width, height);
        context.fillStyle = fill;
        context.fill();
        context.strokeStyle = ink;
        context.lineWidth = 3;
        context.stroke();
    };
    const strap = (points, width) => {
        context.beginPath();
        context.moveTo(points[0], points[1]);
        context.bezierCurveTo(...points.slice(2));
        context.strokeStyle = edge;
        context.lineWidth = width + 4;
        context.stroke();
        context.strokeStyle = ink;
        context.lineWidth = width;
        context.stroke();
    };
    if (behind) {
        if (style === "sling")
            return;
        // A bag sitting behind the shoulder, with the outer side visible beside it.
        // Its bottom is aligned with the torso cut, never hanging into empty space.
        context.beginPath();
        context.moveTo(42, 153);
        context.bezierCurveTo(35, 127, 62, 126, 65, 150);
        context.strokeStyle = ink;
        context.lineWidth = 7;
        context.stroke();
        if (style === "daily-dash") {
            shape(7, 151, 87, 138, 15, "#343834");
            shape(9, 165, 29, 115, 9, "#222622");
            context.beginPath();
            context.moveTo(34, 159);
            context.lineTo(34, 268);
            context.strokeStyle = "#868c80";
            context.lineWidth = 2;
            context.stroke();
            shape(10, 230, 29, 44, 5, "#414a3f");
            context.beginPath();
            context.moveTo(15, 170);
            context.lineTo(29, 168);
            context.strokeStyle = signal;
            context.lineWidth = 3;
            context.stroke();
            // Small, unbranded reflective mark and a pull tab, not a recreated logo.
            shape(18, 179, 3, 11, 1, signal);
            context.fillStyle = edge;
            context.fillRect(17, 254, 8, 2);
        }
        else {
            shape(8, 154, 91, 134, 26, "#756956");
            shape(10, 180, 30, 96, 13, "#a29378");
            context.beginPath();
            context.moveTo(18, 175);
            context.bezierCurveTo(24, 157, 55, 155, 82, 169);
            context.strokeStyle = edge;
            context.lineWidth = 2;
            context.stroke();
            shape(14, 231, 26, 39, 9, "#675f51");
            shape(21, 196, 8, 16, 2, signal);
        }
        return;
    }
    if (style === "sling") {
        // Cross-body webbing meets both ends of the low, close-fitting sling.
        strap([167, 153, 153, 186, 121, 213, 93, 248], 10);
        strap([60, 247, 83, 262, 133, 274, 165, 279], 8);
        context.save();
        context.translate(112, 251);
        context.rotate(-0.2);
        shape(-57, -19, 111, 49, 14, "#363b36");
        context.beginPath();
        context.moveTo(-45, -4);
        context.quadraticCurveTo(1, -11, 43, -4);
        context.strokeStyle = edge;
        context.lineWidth = 2;
        context.stroke();
        shape(31, -4, 4, 12, 1, signal);
        context.fillStyle = "#9ca193";
        context.fillRect(-8, 11, 13, 2);
        context.restore();
        return;
    }
    // The bag is behind the person, so only its shoulder webbing is in front.
    strap([88, 153, 66, 181, 65, 231, 85, 281], style === "daily-dash" ? 12 : 10);
    strap([159, 153, 178, 179, 180, 232, 160, 280], style === "daily-dash" ? 11 : 9);
    if (style === "daily-dash") {
        strap([76, 213, 105, 218, 145, 218, 172, 213], 4);
        shape(119, 212, 11, 8, 2, "#6e7469");
    }
    shape(71, 246, 10, 10, 2, style === "daily-dash" ? "#71796e" : signal);
}
function makeCarryingSprite(sprite, rect, index, accent) {
    const composed = document.createElement("canvas");
    composed.width = Math.ceil(rect[2]);
    composed.height = Math.ceil(rect[3]);
    const context = composed.getContext("2d");
    if (!context)
        return null;
    context.etAccent = accent;
    const variant = index % 6;
    const style = variant < 3 ? "daily-dash" : variant < 5 ? "sling" : "daypack";
    context.save();
    context.scale(composed.width / 240, composed.height / 324);
    paintCarry(context, style, true);
    context.restore();
    context.drawImage(sprite, ...rect, 0, 0, composed.width, composed.height);
    context.save();
    context.scale(composed.width / 240, composed.height / 324);
    paintCarry(context, style, false);
    context.restore();
    return composed;
}

}());
